import { useRef, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ListGroup from "react-bootstrap/ListGroup";
import Button from "react-bootstrap/Button";
import Nav from "react-bootstrap/Nav";
import "../../index.css";
import "./index.css";
import XSeriesData from "./data/XSeries.json";
import YSeriesData from "./data/YSeries.json";
import Quant from "./data/Quant.json";
import ASeriesData from "./data/ASeries.json";
import BSeriesData from "./data/BSeries.json";
import CSeriesData from "./data/CSeries.json";
import ClassicalElectrodynamicsData from "./data/ClassicalElectrodynamics.json";
import ClassicalMechanicsData from "./data/ClassicalMechanics.json";
import QuantXSeriesData from "./data/QuantXSeries.json";
import QuantYSeriesData from "./data/QuantYSeries.json";
import IntellectualBeautyHidingInPhysicsData from "./data/IntellectualBeautyHidingInPhysics.json";
import KPOPEPhysicsLinks from "./data/Links.json";
import GalileoData from "./data/GalileoToEinstein.json";
import MathematicalApproachesData from "./data/MathematicalApproaches.json";
import ReactGA from "react-ga4";
import CourseSeries from "./CourseSeries";

ReactGA.initialize("G-TXK97ETKD6");

const KpopePhysics = () => {
  return (
    <ListGroup style={{ width: "90%", marginTop: "2rem" }}>
      <ListGroup.Item id="purple-bar" active={false} action href="/">
        The Korea Pragmatist Organization for Physics Education (KPOPE)
      </ListGroup.Item>
      <ListGroup.Item id="font-size" active={false} action href="/">
        <div id="flex-container" style={{ marginBottom: "1.3rem" }}>
          <div id="margin-bottom1" style={{ marginRight: "3rem" }}>
            <a
              id="youtube"
              href={KPOPEPhysicsLinks.subscribe_link}
              onClick={ReactGA.event({
                name: "youtube_click",
                params: {
                  category: "Button Clicks", // Define category
                  action: "click", // Define action
                  label: "KPOPE Youtube Button Click", // Define label
                },
              })}
              className="list-group-item-action"
            >
              Free KPOPE Lecture:{" "}
              <img
                id="img-height"
                src={require("../../assets/kpope_subscribe.jpeg")}
                alt=""
              />
            </a>
          </div>
          <div id="margin-bottom1">
            <a
              id="youtube"
              href={KPOPEPhysicsLinks.orchid_link}
              onClick={ReactGA.event({
                name: "orchid_click",
                params: {
                  category: "Button Clicks", // Define category
                  action: "click", // Define action
                  label: "Orchid Button Click", // Define label
                },
              })}
              className="list-group-item-action"
            >
              Publication List:{" "}
              <img
                id="img-height"
                src={require("../../assets/Orcid_icon.png")}
                alt=""
              ></img>
            </a>
          </div>
          <div id="margin-logos">
            <a
              id="youtube"
              href={KPOPEPhysicsLinks.kpope_naver_cafe_link}
              onClick={ReactGA.event({
                name: "kpope_naver_cafe_link",
                params: {
                  category: "Button Clicks", // Define category
                  action: "click", // Define action
                  label: "KPOPE Naver Cafe Button Click", // Define label
                },
              })}
              className="list-group-item-action"
            >
              KPOPE Classroom at Naver Cafe:{" "}
              <img
                id="img-height"
                src={require("../../assets/naverlogo.png")}
                alt=""
              ></img>
            </a>
          </div>
        </div>
        <div id="flex-container">
          <div id="margin-bottom1" style={{ marginRight: "4.5rem" }}>
            <a
              id="youtube"
              href={KPOPEPhysicsLinks.subscribe_link}
              onClick={ReactGA.event({
                name: "kpope_youtube_subscribe_button",
                params: {
                  category: "Button Clicks", // Define category
                  action: "click", // Define action
                  label: "KPOPE Youtube Subscribe Button Click", // Define label
                },
              })}
              className="list-group-item-action"
            >
              Free Subscription:{" "}
              <img
                id="img-height"
                src={require("../../assets/kpope_subscribe.jpeg")}
                alt=""
              />
            </a>
          </div>
          <div id="margin-bottom1" style={{ marginRight: "3rem" }}>
            <a
              id="youtube"
              href={KPOPEPhysicsLinks.inpsire_link}
              onClick={ReactGA.event({
                name: "inspire_click",
                params: {
                  category: "Button Clicks", // Define category
                  action: "click", // Define action
                  label: "Inspire Button Click", // Define label
                },
              })}
              className="list-group-item-action"
            >
              Particle Physics Papers:{" "}
              <img
                id="img-height"
                src={require("../../assets/inspire.jpeg")}
                alt=""
              ></img>
            </a>
          </div>
          <div id="margin-bottom1">
            <a
              id="youtube"
              href={KPOPEPhysicsLinks.quarkvalley_link}
              onClick={ReactGA.event({
                name: "quarkvalley_cafe_click",
                params: {
                  category: "button clicks", // define category
                  action: "click", // define action
                  label: "Quark Valley Button Click", // Define label
                },
              })}
              className="list-group-item-action"
            >
              Quark Valley Camp:{" "}
              <img
                id="img-height"
                src={require("../../assets/quarkvalley.png")}
                alt=""
              ></img>
            </a>
          </div>
        </div>
      </ListGroup.Item>
    </ListGroup>
  );
};

// Export config for use in other components
export const COURSE_SERIES_CONFIG = [
  {
    id: 0,
    slug: "galileo-to-einstein",
    title: "From Galileo to Einstein",
    data: GalileoData,
    headerStyle: "right-bar",
    buttonStyle: "YlectureButton",
    containerStyle: { marginRight: "2rem" },
    layout: "row-left", // left side of row
  },
  {
    id: 1,
    slug: "mathematical-approaches",
    title: "Mathematical Approaches for Classical and Quantum Mechanics",
    data: MathematicalApproachesData,
    headerStyle: "right-bar",
    buttonStyle: "YlectureButton",
    containerStyle: {},
    layout: "row-right", // right side of row
  },
  {
    id: 2,
    slug: "series-x",
    title: "Series X",
    data: XSeriesData,
    headerStyle: "first-bar",
    buttonStyle: "XlectureButton",
    containerStyle: { marginRight: "2rem" },
    layout: "row-left",
  },
  {
    id: 3,
    slug: "series-y",
    title: "Series Y",
    data: YSeriesData,
    headerStyle: "right-bar",
    buttonStyle: "YlectureButton",
    containerStyle: {},
    layout: "row-right",
  },
  {
    id: 4,
    slug: "relativistic-quantum-mechanics",
    title: "Relativistic Quantum Mechanics",
    data: Quant,
    headerStyle: "purple-bar",
    buttonStyle: "QuantButton",
    containerStyle: { width: "90%" },
    layout: "full-width",
  },
  {
    id: 5,
    slug: "series-a",
    title: "Escape from Scientific Absurdity-Series A",
    data: ASeriesData,
    headerStyle: "first-bar",
    buttonStyle: "XlectureButton",
    containerStyle: { marginRight: "3rem" },
    layout: "row-left",
  },
  {
    id: 6,
    slug: "series-b",
    title: "Escape from Scientific Absurdity-Series B",
    data: BSeriesData,
    headerStyle: "right-bar",
    buttonStyle: "YlectureButton",
    containerStyle: {},
    layout: "row-right",
  },
  {
    id: 7,
    slug: "series-c",
    title: "Escape from Scientific Absurdity-Series C",
    data: CSeriesData,
    headerStyle: "purple-bar",
    buttonStyle: "button-3",
    containerStyle: { width: "90%" },
    layout: "full-width",
  },
  {
    id: 8,
    slug: "classical-electrodynamics",
    title: "Classical Electrodynamics",
    data: ClassicalElectrodynamicsData,
    headerStyle: "purple-bar",
    buttonStyle: "button-3",
    containerStyle: { width: "90%" },
    layout: "full-width",
  },
  {
    id: 9,
    slug: "classical-mechanics",
    title: "Classical Mechanics",
    data: ClassicalMechanicsData,
    headerStyle: "purple-bar",
    buttonStyle: "button-3",
    containerStyle: { width: "90%" },
    layout: "full-width",
  },
  {
    id: 10,
    slug: "series-qx",
    title: "Quantum Mechanics - Series QX",
    data: QuantXSeriesData,
    headerStyle: "first-bar",
    buttonStyle: "XlectureButton",
    containerStyle: { marginRight: "3rem" },
    layout: "row-left",
  },
  {
    id: 11,
    slug: "series-qy",
    title: "Quantum Mechanics - Series QY",
    data: QuantYSeriesData,
    headerStyle: "right-bar",
    buttonStyle: "YlectureButton",
    containerStyle: {},
    layout: "row-right",
  },
  {
    id: 12,
    slug: "intellectual-beauty",
    title: "Intellectual Beauty Hiding in Physics",
    data: IntellectualBeautyHidingInPhysicsData,
    headerStyle: "purple-bar",
    buttonStyle: "button-3",
    containerStyle: { width: "90%" },
    layout: "full-width",
  },
];

// Legacy component - redirects to new library catalog
export const GeneralPhysics = () => {
  const navigate = useNavigate();
  
  // Redirect to new library catalog
  useEffect(() => {
    navigate('/library', { replace: true });
  }, [navigate]);

  return null;
};
